namespace Matrix.Rebalancer {
    export namespace TaskTypePropertiesService {
        export const baseUrl = 'Rebalancer/TaskTypeProperties';

        export declare function Create(request: Serenity.SaveRequest<TaskTypePropertiesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<TaskTypePropertiesRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TaskTypePropertiesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TaskTypePropertiesRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/TaskTypeProperties/Create",
            Update = "Rebalancer/TaskTypeProperties/Update",
            Delete = "Rebalancer/TaskTypeProperties/Delete",
            Retrieve = "Rebalancer/TaskTypeProperties/Retrieve",
            List = "Rebalancer/TaskTypeProperties/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>TaskTypePropertiesService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
